import type { ReactNode } from "react";

import styles from "./styles.module.css";

interface SectionHeadingProps {
  /** 小标签，全站每 3 节最多用 1 次 */
  eyebrow?: string;
  title: ReactNode;
  lead?: ReactNode;
  align?: "left" | "center";
  invert?: boolean;
}

export function SectionHeading({ eyebrow, title, lead, align = "left", invert = false }: SectionHeadingProps) {
  return (
    <header className={`${styles.heading} ${styles[align]} ${invert ? styles.invert : ""}`}>
      {eyebrow ? (
        <span className="eyebrow" data-reveal>
          {eyebrow}
        </span>
      ) : null}
      <h2 className={styles.title} data-reveal>
        {title}
      </h2>
      {lead ? (
        <p className={styles.lead} data-reveal>
          {lead}
        </p>
      ) : null}
    </header>
  );
}

export default SectionHeading;
